export enum SumInsuredLimit {
    MAX_VALUE = 1000000000
  }
  